import React from 'react'
import cx from 'classnames'

import MCEditorContext from 'components/MCTextEditor/MCEditorContext'

import cm from '../Toolbar.module.css'

import { getTextLength, getVariablesLength } from './counterUtils'

const Counter = () => {
  const { toolbar, value } = React.useContext(MCEditorContext)
  const { limit = 0, countVariableLength, countEncodedSymbols } = toolbar
  const withLimit = limit > 0

  if (!withLimit) {
    return null
  }

  const counterValue = withLimit
    ? limit -
      getTextLength(value, { encodeSymbols: countEncodedSymbols }) -
      (countVariableLength ? getVariablesLength(value) : 0)
    : 0

  return <span className={cx(cm.counter, counterValue < 0 && 'text-danger')}>{counterValue}</span>
}

export default Counter
